import { useState, useEffect, useCallback } from "react";
import apiFetch from "../../../../shared/services/apiClient";

/**
 * useAsientos — hook para listar asientos de diario con paginación y filtros.
 */
export function useAsientos(params = {}) {
  const [asientos, setAsientos] = useState([]);
  const [count,    setCount]    = useState(0);
  const [loading,  setLoading]  = useState(true);
  const [error,    setError]    = useState(null);

  const cargar = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const qs  = new URLSearchParams({ page_size: 20, ...params }).toString();
      const res = await apiFetch(`/api/finance/asientos/?${qs}`);
      const d   = await res.json();
      setAsientos(d.results ?? []);
      setCount(d.count ?? 0);
    } catch (e) {
      setError("Error al cargar los asientos");
    } finally {
      setLoading(false);
    }
  }, [JSON.stringify(params)]);

  useEffect(() => { cargar(); }, [cargar]);

  return { asientos, count, loading, error, refetch: cargar };
}

/**
 * crearAsientoManual — POST /api/finance/asientos/
 * data = { fecha, concepto, lineas: [{ cuenta, debito, credito, descripcion }] }
 */
export async function crearAsientoManual(data) {
  const res  = await apiFetch("/api/finance/asientos/", {
    method: "POST",
    body:   JSON.stringify(data),
  });
  const body = await res.json();
  if (!res.ok) throw new Error(JSON.stringify(body));
  return body;
}

/**
 * crearFacturasMasivas — POST /api/finance/factura/masivo/
 */
export async function crearFacturasMasivas(data) {
  const res  = await apiFetch("/api/finance/factura/masivo/", {
    method: "POST",
    body:   JSON.stringify(data),
  });
  const body = await res.json();
  if (!res.ok) throw new Error(body.error ?? JSON.stringify(body));
  return body;
}
